module.exports = __webpack_public_path__ + "static/team-22-4975e93f9586da76233b21452db0a9f3.jpg";